import Vue from 'vue';

const JOB_PROGRESS_FIELDS = ['completenessPercentage', 'jobPhases'];

export const applyJobProgress = (job, progress) => {
  if (!job || !progress || !job._id || job._id !== progress._id) return;

  JOB_PROGRESS_FIELDS.forEach((field) => {
    if (progress[field] !== undefined) {
      Vue.set(job, field, progress[field]);
    }
  });
};

export default applyJobProgress;
